import { FontAwesomeIcon } from '@appcharge/shared-ui';

import Switch from 'components/Switch/Switch';
import Typography from 'components/Typography/Typography';

interface CouponsStatusToggleProps {
  isActive: boolean;
  onToggle: (checked: boolean) => void;
  disabled?: boolean;
  dataTestId?: string;
}

const CouponsStatusToggle: React.FC<CouponsStatusToggleProps> = ({
  isActive,
  onToggle,
  disabled,
  dataTestId
}) => {
  return (
    <div
      className={`flex items-center justify-between px-3 py-[11px] rounded-lg mb-5 ${isActive ? 'bg-green-50' : 'bg-base-muted'}`}
    >
      <div className="flex items-center gap-2">
        <FontAwesomeIcon
          icon={isActive ? 'fa-regular fa-lock-open' : 'fa-regular fa-lock'}
          className={`w-4 h-4 ${isActive ? 'text-green-600' : 'text-zinc-500'}`}
        />
        <Typography className="text-sm font-normal text-base-sidebarForeground">
          {isActive ? 'Active' : 'Inactive'}
        </Typography>
        <Typography
          className={`text-sm ${isActive ? 'text-green-600' : 'text-zinc-500'}`}
        >
          |{' '}
          {isActive
            ? 'Promo codes can be applied at checkout.'
            : 'Promo codes cannot be applied at checkout'}
        </Typography>
      </div>
      <Switch
        defaultChecked={isActive}
        onCheckedChange={onToggle}
        disabled={disabled}
        data-testid={dataTestId}
        size="md"
      />
    </div>
  );
};

export default CouponsStatusToggle;
